<template>
  <v-snackbar :value="globalAlert.alert" @input="snackbarClose" :timeout=10000 :color="globalAlert.color" top right>

    <p class="text-h6">
      {{ globalAlert.alertTitle }}
    </p>
    <p>
      {{ globalAlert.alertMessage }}
    </p>

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="globalAlert.alert = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "GlobalAlert",
  data() {
    return {};
  },
  props: {
    globalAlert: {}
  },
  methods: {
    snackbarClose(val) {
      this.globalAlert.alert = val
    }
  },
  created: function () { }
};
</script>